import { I18N_POST_PROCESSORS } from './i18nPostProcessorConstants';

const NBSP_CHARACTER = '\u00A0';
const NBSP_ENTITY_TOKENS = ['&nbsp;'];

const NBSP_ENTITY_PATTERN = new RegExp(
    NBSP_ENTITY_TOKENS.map((token) => token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'),
    'gi',
);

/**
 * Replaces HTML non-breaking-space entities with the actual Unicode character.
 */
export const decodeNbspEntities = (value: string): string => {
    return value.replace(NBSP_ENTITY_PATTERN, NBSP_CHARACTER);
};

/**
 * i18next post-processor to decode NBSP entities in translated strings.
 */
export const nbspEntityPostProcessor = {
    type: 'postProcessor' as const,
    name: I18N_POST_PROCESSORS.decodeNbsp,
    process: (value: unknown): unknown => {
        if (typeof value !== 'string') {
            return value;
        }

        return decodeNbspEntities(value);
    },
};
